module.exports = __webpack_public_path__ + "img/level_two_hover.c2e49ab3.png";